<template>
  <v-menu offset-y v-if="articles.length > 0">
    <template v-slot:activator="{ on }">
      <transition name="slide-fade">
        <v-btn v-on="on" v-show="!loadingData" fab small color="primary" class="pa-n4 mr-1">
          <v-icon small class="mx-n2">mdi-menu-down</v-icon>
          {{ articles.length }}
        </v-btn>
      </transition>
    </template>
    <ArticleTitlesList :articles="articles" @gotopage="goToPage"></ArticleTitlesList>
  </v-menu>
</template>

<script>
import ArticleTitlesList from '@/components/ArticleTitlesList.vue'
export default {
  components: {
    ArticleTitlesList
  },
  props: {
    articles: {
      type: Array,
      default: () => []
    },
    loadingData: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goToPage(page) {
      this.$emit('gotopage', page)
    }
  }
}
</script>

<style>
.slide-fade-enter-active {
  transition: all 2s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(40px);
  opacity: 0;
}
</style>
